import { ReactNode } from 'react';
import styles from './Tooltip.module.scss';

interface ITooltipProps {
  content: ReactNode;
  children: ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

const Tooltip = ({ content, children, position = 'top', className = '' }: ITooltipProps) => {
  return (
    <div className={`${styles.container} ${className}`}>
      {children}
      <div className={`${styles.tooltip} ${styles[position]}`}>{content}</div>
    </div>
  );
};

export default Tooltip;
